import { logoutUser } from '@sit/client-shared';
import { useQueryClient } from '@tanstack/react-query';
import { track } from '@web/analytics/analyticsClient';
import trackEvents from '@web/analytics/trackEvents';
import { authStore } from '@web/auth/auth-store';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useCallback(async () => {
    const token = authStore.getToken();
    const refreshToken = authStore.getRefreshToken();
    authStore.logout();
    try {
      await logoutUser(token, refreshToken);
    } catch {
      // Do nothing, continue to logout
    }
    navigate('/login');
    track(trackEvents.LOGOUT);
    sessionStorage?.clear();
    queryClient.clear();
  }, [queryClient, navigate]);
}
